var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d6fa59;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228.06,57.53H95.87c-17.28,0-31.35,14.06-31.35,31.35v8.85c0,9.58,4.33,18.17,11.12,23.92-6.8,5.75-11.12,14.34-11.12,23.93v8.85c0,9.59,4.33,18.18,11.13,23.93-6.8,5.76-11.13,14.35-11.13,23.94v8.81c0,17.29,14.07,31.37,31.37,31.37H228.06l7.42-7.42V64.95l-7.42-7.42ZM79.36,97.72v-8.85c0-9.1,7.4-16.5,16.5-16.5h124.77v13.51H97.88v14.84h122.76v13.51H95.87c-9.1,0-16.5-7.4-16.5-16.5Zm16.5,73.2c-9.1,0-16.5-7.4-16.5-16.5v-8.85c0-9.1,7.4-16.5,16.5-16.5h124.77v13.51H97.88v14.84h122.76v13.51H95.87Zm.02,56.7c-9.11,0-16.52-7.41-16.52-16.52v-8.81c0-9.11,7.41-16.52,16.52-16.52h124.75v14.59H97.88v14.84h122.76v12.42H95.89Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFold);
export default __webpack_public_path__ + "static/media/fold.24ead4b2dabaa8511f6bc9b866e4f48a.svg";
export { ForwardRef as ReactComponent };